/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import JoditEditor from 'jodit-react';
import jodit from '../../../utils/jodit';
import './style.css';

const RichTextEditorViewer = ({ value = null, makeup = false }) => {
	const config = useMemo(
		() => ({
			showPlaceholder: false,
			toolbarSticky: false,
			toolbarAdaptive: false,
			toolbarInlineForSelection: false,
			inline: true,
			readonly: true,
			toolbar: false,
			statusbar: false,
			buttons: '',
			controls: jodit?.controls,
		}),
		[]
	);

	return (
		<Box width="100%" className="np-jodit-viewer">
			<Box width="100%" className={makeup ? 'makeup' : ''}>
				<JoditEditor value={value} config={config} />
			</Box>
		</Box>
	);
};

export default RichTextEditorViewer;
